import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export interface CreditTransactionDto {
  id: string;
  kind: string;
  amount: number;
  balanceAfter: number;
  relatedJobId?: string | null;
  createdAt: string;
}

export interface CreditsBalanceDto {
  balance: number;
  recentTransactions: CreditTransactionDto[];
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export function useCreditsBalance() {
  const { getToken } = useAuth();
  return useQuery<CreditsBalanceDto>({
    queryKey: ['credits'],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const response = await client
        .get('api/v2/me/credits')
        .json<ApiResponse<CreditsBalanceDto>>();
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
}

export function useTopUpCredits() {
  const { getToken } = useAuth();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const client = createApiClient(getToken);
      await client.post('api/v2/me/credits/topup');
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['credits'] }),
  });
}
